export default __webpack_public_path__ + "static/media/collagen@3x.f4504b66.jpg";